import React from "react";
import { useNavigate } from "react-router-dom";

const tableHead = [
  "Sr.",
  "Date",
  "Name",
  "Contact Number",
  "Time Slot",
  "Status",
  "Site Inspection",
  "Actions",
];

const SIschedulesTables = ({ data = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();

  const goToView = (id) => {
    navigate(`/si-schedules/view/${id}`);
  };
  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={index}>
                <td>{Index}</td>
                <td>
                  {item?.finalDate
                    ? item?.finalDate
                    : item?.prefferedDate
                    ? item?.prefferedDate
                    : "N/A"}
                </td>
                <td>{item?.fullName || "N/A"}</td>
                <td>{item?.contactNumber || "N/A"}</td>
                <td>
                  {item?.finalDate && item?.timeSlot
                    ? item.timeSlot
                    : item?.prefferedDate && item?.timeSlot
                    ? "Requested"
                    : "N/A"}
                </td>
                <td>
                  {item?.finalDate ? (
                    <span className="badge bg-green text-white">Confirm</span>
                  ) : item?.prefferedDate ? (
                    <span className="badge bg-yellow text-white">Pending</span>
                  ) : (
                    "N/A"
                  )}
                </td>
                <td className="text-center">
                  {item?.siteInspectionStatus ? (
                    <span className="badge bg-green text-white">Completed</span>
                  ) : (
                    <span className="badge bg-yellow text-white">Pending</span>
                  )}
                </td>
                {/* <td>{item?.dateofSI ? "schedules": "N/A" }</td> */}
                <td>
                  {/* {item.finalDate ? <button onClick={() => goToView(item?.orderId)} className="btn btn-primary">Edit Final Schedule</button> : "N/A"} */}
                  {item.finalDate || item?.prefferedDate ? (
                    <button
                      onClick={() => goToView(item?.orderId)}
                      className="btn btn-primary"
                    >
                      View
                    </button>
                  ) : (
                    "N/A"
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default SIschedulesTables;
